import deepPurple from "@material-ui/core/colors/deepPurple";

const drawerWidth = 600;
const toolDrawerWidth = 160;

export const styles = (theme) => ({
    root: {
        display: "flex",
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 36,
    },
    hide: {
        display: "none",
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: "nowrap",
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: "hidden",
        width: theme.spacing(7 + 1),
        [theme.breakpoints.up("sm")]: {
            width: theme.spacing(7 + 1),
        },
    },
    toolDrawerOpen: {
        backgroundColor: "rgba(242,245,251, 0.5)",
        width: toolDrawerWidth,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    toolDrawerClose: {
        backgroundColor: "rgba(242,245,251, 0.5)",
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: "hidden",
        width: theme.spacing(7 + 1),
        [theme.breakpoints.up("sm")]: {
            width: theme.spacing(7 + 1),
        },
    },
    toolbar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: "0 8px",
        minHeight: "48px",
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        height: "100%",
    },
    purpleAvatar: {
        margin: 5,
        color: "#fff",
        backgroundColor: deepPurple[500],
    },
    grow: {
        flexGrow: 1,
        font: "22pt 'Futura', sans-serif",
        textAlign: "left",
    },
    drawerPaper: {
        backgroundColor: "rgba(242,245,251, 0.6)",
        width: 160,
    },
    toolMenuText: {
        textAlign: "right",
    },
    toolListItem: {
        paddingRight: "0px",
        minWidth: toolDrawerWidth,
    },
    snackbar: {
        zIndex: "10100",
        backgroundColor: "#ff9800",
    },
    calculating: {
        color: "#ffffff",
        position: "fixed",
        zIndex: "10000",
        fontSize: "7pt",
        paddingLeft: "84px",
        bottom: "-1px",
    },
    bom: {
        position: "fixed",
        zIndex: "10001",
        left: "0px",
        top: "0px",
        height: "100%",
        width: "60%",
        borderRadius: "0px",
        textAlign: "left",
        display: "flex",
        background: "white",
    },
    display_options: {
        position: "fixed",
        zIndex: "1400",
        right: "0px",
        top: "0px",
        height: "100%",
        width: "380px",
        borderRadius: "0px",
        textAlign: "left",
        display: "flex",
        backgroundColor: "#edf0f3e8",
        borderLeft: "3px solid #0000001f",
        backdropFilter: "blur(4px)",
    },

    bom2: {
        position: "fixed",
        zIndex: "10001",
        left: "0px",
        top: "0px",
        height: "100%",
        width: "60%",
        borderRadius: "0px",
        textAlign: "left",
        display: "flex",
        background: "white",
        "& .react-resizable-handle": {
            position: "absolute",
            width: 20,
            height: "100%",
            top: 0,
            bottom: 0,
            right: 0,
            background:
                "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+')",
            backgroundPosition: "right center",
            padding: "0 3px 3px 0",
            "background-repeat": "no-repeat",
            "background-origin": "content-box",
            "box-sizing": "border-box",
            cursor: "e-resize",
        },
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
    draggerEW: {
        width: "5px",
        cursor: "ew-resize",
        padding: "4px 0 0",
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        zIndex: "100",
        backgroundColor: "#c7ccd0",
        "-webkit-user-drag": "none",
        "&:hover": {
            backgroundColor: "#a7aca0",
        },
    },
    draggerNS: {
        height: "5px",
        width: "100%",
        cursor: "ns-resize",
        padding: "4px 0 0",
        borderTop: "1px solid #ddd",
        position: "absolute",
        left: 0,
        bottom: "-5px",
        zIndex: "100",
        backgroundColor: "#c7ccd0",
        "-webkit-user-drag": "none",
        "&:hover": {
            backgroundColor: "#a7aca0",
        },
    },
    gripLeft: {
        position: "absolute",
        left: "-30px",
        height: "25%",
        width: "32px",
        color: "#fff",
        cursor: "grab",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderTopLeftRadius: "6px",
        borderBottomLeftRadius: "6px",
        boxShadow: "-3px 4px 4px rgba(0,0,0,0.2)",
    },
    gripRight: {
        position: "absolute",
        right: "-30px",
        bottom: 0,
        height: "25%",
        width: "32px",
        color: "#fff",
        cursor: "grab",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderTopRightRadius: "6px",
        borderBottomRightRadius: "6px",
        boxShadow: "-3px 4px 4px rgba(0,0,0,0.2)",
    },
    selectPointNote: {
        maxWidth: "450px",
        textAlign: "left",
        top: "100px",
        padding: "10px",
        background: "#d7751bab",
        position: "absolute",
        right: "12px",
        zIndex: "5",
        color: "white",
    },
});
